import { withViewModel } from '../../../../../../../../infrastructure/components/with-view-model';
import { TConnection } from '../../../../../../../../api/blueprints/connection.template.types';
import { ConnectionZoomMeetingFormVM } from './connection-zoom-meeting-form.viewmodel';
import { ConnectionZoomMeetingFormPresentation } from './connection-zoom-meeting-form.presentation';
import { ConnectionVersion } from '../../../../../../../../constants/common.constants';

type ConnectionZoomMeetingTemplateFormProps = {
    connection: TConnection;
    isAutoSyncLimitReached: boolean;
    addConnection: (connection: TConnection) => void;
    editConnection: (connection: TConnection) => void;
    connectionVersion: ConnectionVersion;
};

export const ConnectionZoomMeetingTemplateForm = withViewModel(ConnectionZoomMeetingFormPresentation, (props: ConnectionZoomMeetingTemplateFormProps) => {
    const vm = new ConnectionZoomMeetingFormVM(
        props.connection, props.addConnection, props.editConnection, props.connectionVersion, props.isAutoSyncLimitReached
    );

    return vm;
});
